import React from 'react';

export default function ModifiedBadge() {
  return (
    <span className="text-xs uppercase font-semibold text-k-orange">
      modified
    </span>
  );
}
